import { createFileRoute, redirect } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { CustomerReport } from '../components/CustomerReport';
import { employeeProjectModelService } from '../services/employeeProjectModelService';

const SELECTED_PROJECT_STORAGE_KEY = 'customer-report-selected-project-id';

export const Route = createFileRoute('/customer-report')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!user) {
      throw redirect({ to: '/time-entry' });
    }
    // Non-admin access is enforced by the backend, which answers 403 when the
    // user holds no project role assignments.
  },
  loader: async ({ context }) => {
    const { queryClient } = context;
    await queryClient.prefetchQuery({
      queryKey: ['employee-project-models'],
      queryFn: () => employeeProjectModelService.getEmployeeProjectModels(),
      staleTime: 1000 * 60 * 5,
    });
  },
  component: CustomerReportRoute,
});

function CustomerReportRoute() {
  const queryClient = useQueryClient();
  const [selectedProjectId, setSelectedProjectId] = useState<string>(
    () => localStorage.getItem(SELECTED_PROJECT_STORAGE_KEY) || '',
  );

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ['projects', 'by-role'] });
    queryClient.invalidateQueries({ queryKey: ['log-projects'] });
    queryClient.invalidateQueries({ queryKey: ['customer-report'] });
  }, [queryClient]);

  const handleProjectChange = (projectId: string) => {
    setSelectedProjectId(projectId);
    localStorage.setItem(SELECTED_PROJECT_STORAGE_KEY, projectId);
  };

  return (
    <CustomerReport
      selectedProjectId={selectedProjectId}
      onProjectChange={handleProjectChange}
    />
  );
}
